/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react'
import classnames from 'classnames'
import { Button2 } from '../Button2/Button2'
import style from './ActionButton.module.css'
import { LoaderIcon } from './components/LoaderIcon'

interface IActionButtonProps {
  link?: string
  tabIndex?: number
  children: string
  className?: string
  onClick?(): void
  isExternal?: boolean
  codeFormError?: string
}

export const ActionButton: FC<IActionButtonProps> = ({ children, codeFormError, className, ...props }) => {
  const classNames = classnames(style.actionButton, className)

  return (
    <Button2 {...props} className={classNames}>
      <LoaderIcon className={style.icon} />
      {children}
    </Button2>
  )
}

ActionButton.displayName = 'ActionButton'
